import { Field } from 'formik';
import { Input, FormControl, Grid, GridItem, Box, Link } from '@chakra-ui/react';
import ElementInstructions from './components/ElementInstructions';
import ElementHeading from './components/ElementHeading';
import ElementErrorMessage from './components/ElementErrorMessage';
import { transformRSInput } from '../formControllers/Transformation/Utils.js';
import InputWrapper from './components/InputWrapper';
import { onLink } from '../handlers';
import { getUsefulVars } from '../handlers/helpers';

const Text = ({ fieldName, qObj, jobSeekerData, handlers, props, index }) => {
  const sectionName = props.stateProps.sectionData.sectionName;
  const uv = getUsefulVars(props);
    return (
    <Box >
      <Field name={fieldName}>
      {({ field, form }) => (
        <FormControl
          isInvalid={form.errors[fieldName] && form.touched[fieldName]}
        >
          <Grid >
            <GridItem>
              <ElementHeading qObj={qObj} props={props} />
            </GridItem>
          </Grid>
          {sectionName !== 'new-aptitude' &&
          <ElementInstructions instructions={qObj.instructions} />
          }
          <InputWrapper>
            <Input
              name={field.name}
              value={typeof field.value === 'undefined' ? '' : field.value}
              placeholder={qObj.placeholder}
              onChange={e =>
                transformRSInput(e, jobSeekerData, index, qObj, props)
              }
            />
          </InputWrapper>
          {sectionName === 'new-aptitude' &&
            <Link
              onClick={() => onLink(false, uv.formikProps, uv.stateProps, 'holland-code', 0, 'section', uv.resumeIndex, props)}
              color='#2642bb' textDecoration='underline' float='right' isExternal>Take quiz</Link>
          }
          <ElementErrorMessage form={form} index={qObj.index} qid={qObj.qid} />
        </FormControl>
      )}
    </Field>
      </Box>
  );
};

export default Text;
/*



 */
